import { render, staticRenderFns } from "./relativer.vue?vue&type=template&id=e97c9c26&"
import script from "./relativer.vue?vue&type=script&lang=js&"
export * from "./relativer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports